const initialState = {
  cardClickPrevented: false,
  currentCardData: [],
  currentCardIteration: 0,
  defaultEventsPrevented: false,
  dragging: false,
  loading: false,
  progress: 0,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'CHANGE_CARD_ITERATION':
      return Object.assign({}, state, {
        currentCardIteration: action.iteration,
      });

    case 'CONTENT_DRAGGING':
      return Object.assign({}, state, {
        dragging: action.dragging,
      });

    case 'CARD_CHANGED':
      return Object.assign({}, state, {
        currentCardIteration: action.iteration,
      });

    case 'CARD_DATA_CHANGED':
      return Object.assign({}, state, {
        currentCardData: action.data,
      });

    case 'PROGRESS_CHANGED':
      return Object.assign({}, state, {
        progress: action.progress,
      });

    case 'LOADING':
      return Object.assign({}, state, {
        loading: action.loading,
      });

    case 'DEFAULT_EVENTS_PREVENTED':
      return Object.assign({}, state, {
        defaultEventsPrevented: action.defaultEventsPrevented,
      });

    case 'CARD_CLICK_PREVENTED':
      return Object.assign({}, state, {
        cardClickPrevented: action.cardClickPrevented,
      });

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./assets/js/src/reducers/small-card-framework.js
 **/